<template>
  <div>
    <div
      style="display: flex;align-items: center;padding-bottom: 15px;font-size: 14px;color: rgba(0, 0, 0, 0.4);"
    >
      <span @click="pageBack" style="height: 100%;cursor: pointer;"
        >评价管理</span
      >
      <span style="margin: 0 5px;">
        <i class="el-icon-arrow-right"></i>
      </span>
      <span @click="pageBack" style="height: 100%;cursor: pointer;"
        >查看课程</span
      >
      <span style="margin: 0 5px;">
        <i class="el-icon-arrow-right"></i>
      </span>
      <div style="font-weight: 600;color: rgba(0, 0, 0, 0.9);">
        {{ checkCourse.title }}-查看报告
      </div>
    </div>

    <div class="JsonTit">
      <div
        style="width:94%;margin: 0 auto;font-size: 26px;color: rgba(0, 0, 0, 0.9);"
      >
        {{ checkCourse.title }}
      </div>
      <div class="JsonTitBtn">
        <el-button
          v-if="checkCourse.state == 5 || checkCourse.state == 6"
          @click="exportWorkPdf"
          type="primary"
          size="small"
          >一键导出</el-button
        >
        <el-button
          v-if="checkCourse.state == 5 || checkCourse.state == 6"
          @click="batchExportPdf"
          :type="multipleSelection.length < 2 ? 'info' : 'primary'"
          :disabled="multipleSelection.length < 2"
          size="small"
          >批量导出</el-button
        >

        <el-button
          style="margin-left: 20px;"
          @click="pageBack"
          type="primary"
          size="small"
          >返回</el-button
        >
      </div>
    </div>

    <div
      class="student_search"
      style="margin-bottom: 10px;justify-content: space-between;width: 94%;margin:30px auto;"
    >
      <div
        style="display: flex;justify-content: space-between;align-items: center;width: 650px;"
      >
        <div style="margin-right: 10px;">筛选</div>
        <div>
          <el-select
            class="r_select"
            v-model="uClass"
            placeholder="请选择班级"
            filterable
            @change="searchWork2"
          >
            <el-option label="所有班级" value></el-option>
            <el-option
              v-for="item in classAarray"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <el-select
          class="r_select"
          v-model="uname"
          placeholder="请选择学生"
          @change="searchWork2"
        >
          <el-option label="所有学生" value></el-option>
          <el-option
            v-for="item in userAarray"
            :key="item.userid"
            :label="item.sName"
            :value="item.userid"
          >
          </el-option>
        </el-select>

        <div class="typeCheck">
          <el-switch v-model="typeCheckN"></el-switch
          ><span style="font-size: 14px;">查看所有学生</span>
        </div>
      </div>
    </div>
    <div class="TableCss">
      <el-table
        v-loading="isLoading2"
        ref="multipleTable"
        :data="lookReportTab"
        :fit="true"
        style="width: 100%"
        :header-cell-style="{ background: 'rgb(238,238,238)' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="checkCourse.state == 5 || checkCourse.state == 6"
          key="1"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="sName"
          label="姓名"
          min-width="20"
          align="center"
        ></el-table-column>
        <el-table-column
          label="班级"
          min-width="20"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <div class="ellipsis">
              {{ scope.row.class ? scope.row.class : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="20">
          <template slot-scope="scope">
            <el-button
              v-if="checkCourse.state == 5 || checkCourse.state == 6"
              type="primary"
              size="small"
              @click="lookPdf(scope.row)"
              >查看报告</el-button
            >
            <el-button
              v-else
              type="primary"
              size="small"
              @click="getReport(scope.row)"
              >查看报告</el-button
            >
            <el-button
              v-if="checkCourse.state == 5 || checkCourse.state == 6"
              type="primary"
              size="small"
              @click="getPdf(scope.row)"
              >导出报告</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        v-if="!typeCheckN"
        style="display: flex;justify-content: space-between; padding:15px 0"
      >
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="total2"
          @current-change="handleCurrentChange2"
        ></el-pagination>
        <div style="display: flex;" class="dialog-footer"></div>
      </div>
    </div>

    <!-- ai查看报告 -->
    <el-dialog
      :visible.sync="worksDialog"
      :before-close="handleClose"
      class="worksDialogCSSExp"
      style="overflow: hidden;"
      :append-to-body="true"
      :fullscreen="true"
    >
      <div slot="title" class="header-title">
        <div style="color: #fff">
          {{ this.digNum == 2 ? "查看" : "导出" }}报告
        </div>
      </div>
      <exportDataDialog
        v-if="checkCourse.state == 5 || checkCourse.state == 6"
        :key="exportW"
        :digNum="digNum"
        :oid="oid"
        :isAllWork="isAllWork"
        :classAarray="classAarray"
        :multipleSelection="multipleSelection"
        :worksCon="worksDialogCon"
        :worksDialog.sync="worksDialog"
        :cid="checkCourse.courseId"
      >
      </exportDataDialog>
      <!-- 非ai查看报告 -->
      <div v-else class="report_box">
        <studentReport
          :checkCourse="checkCourse.courseId"
          :checkStudent="checkStudent"
          @cancelR="cancelR"
          :oid="oid"
        ></studentReport>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="workFrame"
      width="500px"
      style="overflow: hidden;margin-top: 20vh;"
      :append-to-body="true"
      :before-close="handleClose">
      <span>是否同步导出学生作业集?</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="workFrame = false">取消</el-button>
        <el-button size="small" type="primary" @click="downloadPdf(0)">仅报告</el-button>
        <el-button size="small" type="primary" @click="downloadPdf(1)">报告（含作业集）</el-button>
      </span>
    </el-dialog>
    <!-- <div style="width: 30px;" v-if="workFrame">
      <div style="margin-top: 10px;">提示</div>
      <div style="width: 100%;text-align: center;margin: 15px 0;">是否同步导出学生作业集?</div>
      <div>
        <el-button size="small" @click="workFrame = false">取消</el-button>
        <el-button size="small" type="primary" @click="downloadPdf(0)">仅报告</el-button>
        <el-button size="small" type="primary" @click="downloadPdf(1)">报告（含作业集）</el-button>
      </div>
    </div> -->

  </div>
</template>

<script>
import exportDataDialog from "./exportDataDialog.vue";
import studentReport from "./studentReport.vue";

export default {
  props: ["signDialog", "checkCourse", "oid"],
  components: {
    exportDataDialog,
    studentReport
  },
  data() {
    return {
      // 查看报告table数据
      lookReportTab: [],
      exportW: 0,
      // 是否导出作业集
      isAllWork:false,

      // 导出报告弹框
      workFrame:false,
      multipleSelection: [],
      worksDialog: false,
      digNum: 0,
      reportVisible: false,
      checkStudent: "",
      userAarray: [],
      classAarray: [],
      uname: "",
      uClass: "",
      typeCheckN: false,
      page2: 1,
      total2: 0,
      isLoading2: false,
      worksDialogCon: {}
    };
  },
  mounted() {
    this.getStudnet2();
  },
  watch: {
    typeCheckN(newValue, oldValue) {
      this.getStudnet2();
    },
    signDialog(newValue, oldValue) {
      this.getStudnet2();
    }
  },
  methods: {
    // 批量选择作业
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // ai查看报告
    lookPdf(val) {
      this.worksDialogCon = val;
      this.worksDialog = true;
      this.digNum = 2;
      this.exportW++;
    },
    // 一键导出
    exportWorkPdf() {
      this.$confirm("一键导出所有报告需要占用您大量时间，是否导出？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.worksDialog = true;
          this.digNum = 1;
          this.exportW++;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 批量导出
    batchExportPdf() {
      this.$confirm("批量导出报告需要占用您一些时间，是否导出？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {

          this.worksDialog = true;

          this.digNum = 0;
          this.exportW++;
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadPdf(val){
    
        if (val) {
          this.isAllWork = true
        }else{
          this.isAllWork = false
        }
        this.digNum = 0;
        this.exportW++;

        this.workFrame = false
        this.worksDialog = true;

        // this.worksDialogCon = val;
        // this.worksDialog = true;

        // this.multipleSelection = [];
        // this.multipleSelection.push(val);
        // this.digNum = 0;
        // this.exportW++;
       
    },
    // 导出报告
    getPdf(val) {
      // this.$confirm("直接导出报告需要占用您一些时间，是否导出？", "提示", {
      //   confirmButtonText: "确认",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     console.log("val", val);
          this.workFrame = true

          this.worksDialogCon = val;

          this.multipleSelection = [];
          this.multipleSelection.push(val);
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    // 关闭弹框返回查看课程
    pageBack() {
      this.$emit("update:signDialog", false);
    },

    getStudnet2() {
      this.isLoading2 = true;

      let params = {
        cid: this.checkCourse.courseId,
        uCla: this.uClass,
        uname: this.uname,
        tck: this.typeCheckN ? 1 : 2,
        stage: "",
        task: "",
        page: this.page2
      };
      // 获取学生列表
      this.ajax
        .get(this.$store.state.api + "getCourseWorks3Copy1", params)
        .then(res => {
          this.isLoading2 = false;
          this.total2 = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.lookReportTab = res.data[0];
          this.userAarray = res.data[1];
          this.classAarray = res.data[2];
        })
        .catch(err => {
          this.isLoading2 = false;
          console.error(err);
        });
    },
    // 非ai查看报告
    getReport(row) {
      this.checkStudent = row.userid;
      this.worksDialog = true;
      // this.signDialog = false;
    },
    cancelR() {
      this.checkStudent = "";
      this.worksDialog = false;
      // this.signDialog = true;
    },

    // 分页切换
    handleCurrentChange2(val) {
      this.page2 = val;
      this.getStudnet2();
    },

    // 查看报告筛选班级
    searchWork2() {
      this.page2 = 1;
      this.getStudnet2();
    },
    handleClose(done) {
      done();
    }
  }
};
</script>

<style scoped>
.TableCss {
  width: 94%;
  margin: auto;
}
/* .TableCss >>> .el-table__header-wrapper .el-table__header .el-checkbox {
  display: none;
} */
.JsonTit {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.JsonTitBtn {
  display: flex;
  align-items: center;
}
.typeCheck {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 10px;
  /* margin-bottom: 20px; */
}
.typeCheck > span {
  margin-left: 10px;
}

.worksDialogCSSExp >>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
}

.worksDialogCSSExp >>> .el-dialog__wrapper {
  overflow: hidden !important;
}
.worksDialogCSSExp >>> .el-dialog__body {
  width: 100% !important;
  padding: 0 !important;
  height: calc(100% - 48px);
  overflow: auto;
}
.worksDialogCSSExp >>> .el-dialog.is-fullscreen {
  overflow: hidden;
}
.report_box {
  height: 100%;
  position: absolute;
  top: 0;
  /* background: #fff; */
  background: rgb(231, 242, 252);
  overflow: auto;
  z-index: 1;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/components/lookReport.vue